'use client';

import { useTranslations } from 'next-intl';
import FadeInSection from '@/components/ui/FadeInSection';
import MultiStepForm from '@/components/ui/MultiStepForm';

export default function FormSection() {
  const t = useTranslations('form');

  return (
    <section
      id="calc-form"
      className="relative scroll-mt-2 overflow-hidden border-t border-surface-bright/15 bg-surface-bright/5 px-margin-mobile py-section-gap lg:scroll-mt-4 lg:px-margin-desktop"
    >
      {/* The spotlight: a still pool of light centred on the form — the one lit
          object at the end of the journey. Static by design; the conversion
          zone gets no parallax and no particles. */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 [background:radial-gradient(55%_45%_at_50%_58%,rgb(var(--c-primary)/0.07),transparent_70%)]"
      />
      <div className="mx-auto w-full max-w-6xl">
        <div className="mx-auto max-w-3xl text-center">
          {/* Heading slides in from the left, subheadline from the right. */}
          <FadeInSection direction="right" distance={64}>
            <p className="text-label-caps uppercase tracking-widest text-primary">{t('eyebrow')}</p>
            <h2 className="mt-stack-md font-headline text-headline-lg font-bold tracking-[0.02em] text-on-surface">
              {t('headline')}
            </h2>
          </FadeInSection>
          <FadeInSection direction="left" distance={64} delay={0.15}>
            <p className="mt-stack-md text-body-md text-on-surface-variant md:text-body-lg">
              {t('subheadline')}
            </p>
          </FadeInSection>
        </div>

        <FadeInSection delay={0.1} className="mx-auto mt-stack-lg w-full max-w-2xl">
          <div className="forest-card p-4 sm:p-6 md:p-10">
            <MultiStepForm />
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
